/** Toolbar buttons — match Leads / Campaigns page headers. */
export const aiOutlineBtn =
  "h-10 !border-line bg-white px-3.5 font-semibold text-dark-blue hover:bg-paper";
export const aiPrimaryBtn = "h-10 px-3.5 font-semibold text-dark-blue";

/** Compact per-row / card actions — closer to list row controls (h-8 text-xs). */
export const aiActionOutlineBtn =
  "h-8 !border-line bg-white px-2.5 text-xs font-semibold text-dark-blue hover:bg-paper";
export const aiActionPrimaryBtn =
  "h-8 px-2.5 text-xs font-semibold text-dark-blue";
export const aiActionGhostBtn =
  "h-8 px-2.5 text-xs font-semibold text-muted";
export const aiActionLinkBtn =
  "h-8 px-2.5 text-xs font-semibold text-brand-blue";
